import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBell,
  faHeart,
  faCalendar,
  faBookmark,
  faUserCircle,
  faTrashAlt
} from "@fortawesome/free-regular-svg-icons";

library.add( faBell, faHeart, faCalendar, faBookmark, faUserCircle, faTrashAlt);
